// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");

var mathModeBegin = "`".codePointAt(0);

var labelModeBegin = "~".codePointAt(0);

var space1 = " ".codePointAt(0);

var space2 = "\t".codePointAt(0);

var space3 = "\r".codePointAt(0);

var space4 = "\n".codePointAt(0);

var space5 = "\f".codePointAt(0);

function splitCommentIntoParts(text) {
  var incRef = function (ref) {
    ref.contents = ref.contents + 1 | 0;
  };
  var isWhitespace = function (ch) {
    if (Caml_obj.equal(ch, space1) || Caml_obj.equal(ch, space2) || Caml_obj.equal(ch, space3) || Caml_obj.equal(ch, space4)) {
      return true;
    } else {
      return Caml_obj.equal(ch, space5);
    }
  };
  var isWhitespaceAt = function (idx) {
    return isWhitespace(text.codePointAt(idx));
  };
  var isWhitespaceAtRef = function (idx) {
    return isWhitespace(text.codePointAt(idx.contents));
  };
  var textBetweenRef = function (idx1, idx2) {
    return text.substring(idx1.contents, idx2.contents);
  };
  var res = [];
  var prevIdx = {
    contents: 0
  };
  var idx = {
    contents: 0
  };
  var maxIdx = text.length - 1 | 0;
  var mathMode = false;
  var labelMode = false;
  while(idx.contents <= maxIdx) {
    var curChar = text.codePointAt(idx.contents);
    incRef(idx);
    if (Caml_obj.equal(curChar, mathModeBegin) && Caml_obj.equal(text.codePointAt(idx.contents), mathModeBegin)) {
      incRef(idx);
    } else if (mathMode) {
      if (Caml_obj.equal(curChar, mathModeBegin) && (isWhitespaceAtRef(idx) || maxIdx < idx.contents) && isWhitespaceAt(idx.contents - 2 | 0)) {
        res.push({
              TAG: "MathMode",
              _0: text.substring(prevIdx.contents + 1 | 0, idx.contents - 1 | 0)
            });
        mathMode = false;
        prevIdx.contents = idx.contents;
      }
      
    } else if (Caml_obj.equal(curChar, labelModeBegin) && Caml_obj.equal(text.codePointAt(idx.contents), labelModeBegin)) {
      incRef(idx);
    } else if (labelMode) {
      if (isWhitespace(curChar)) {
        res.push({
              TAG: "LabelMode",
              _0: text.substring(prevIdx.contents + 1 | 0, idx.contents)
            });
        labelMode = false;
        prevIdx.contents = idx.contents - 1 | 0;
      }
      
    } else if (Caml_obj.equal(curChar, mathModeBegin) && isWhitespaceAtRef(idx) && (isWhitespaceAt(idx.contents - 2 | 0) || idx.contents === 1)) {
      if ((idx.contents - prevIdx.contents | 0) > 1) {
        res.push({
              TAG: "Text",
              _0: text.substring(prevIdx.contents, idx.contents - 1 | 0)
            });
      }
      mathMode = true;
      prevIdx.contents = idx.contents - 1 | 0;
      incRef(idx);
    } else if (Caml_obj.equal(curChar, labelModeBegin) && isWhitespaceAtRef(idx) && (isWhitespaceAt(idx.contents - 2 | 0) || idx.contents === 1)) {
      if ((idx.contents - prevIdx.contents | 0) > 1) {
        res.push({
              TAG: "Text",
              _0: text.substring(prevIdx.contents, idx.contents - 1 | 0)
            });
      }
      labelMode = true;
      prevIdx.contents = idx.contents - 1 | 0;
      incRef(idx);
    }
    
  };
  var postProcessIsNeeded = true;
  if (prevIdx.contents <= maxIdx) {
    if (mathMode) {
      res.push({
            TAG: "MathMode",
            _0: text.substring(prevIdx.contents + 1 | 0, idx.contents)
          });
    } else if (labelMode) {
      res.push({
            TAG: "LabelMode",
            _0: text.substring(prevIdx.contents + 1 | 0, idx.contents)
          });
    } else if (prevIdx.contents > 0) {
      res.push({
            TAG: "Text",
            _0: textBetweenRef(prevIdx, idx)
          });
    } else {
      res.push({
            TAG: "Text",
            _0: text.replaceAll("``", "`").replaceAll("~~", "~")
          });
      postProcessIsNeeded = false;
    }
  }
  if (postProcessIsNeeded) {
    return res.map(function (part) {
                switch (part.TAG) {
                  case "Text" :
                      return {
                              TAG: "Text",
                              _0: part._0.replaceAll("``", "`").replaceAll("~~", "~")
                            };
                  case "MathMode" :
                      return {
                              TAG: "MathMode",
                              _0: part._0.replaceAll("``", "`").trim()
                            };
                  case "LabelMode" :
                      return {
                              TAG: "LabelMode",
                              _0: part._0.replaceAll("``", "`").replaceAll("~~", "~").trim()
                            };
                  
                }
              });
  } else {
    return res;
  }
}

exports.splitCommentIntoParts = splitCommentIntoParts;
/* mathModeBegin Not a pure module */
